import _objectSpread from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { reactive, toRefs } from 'vue';
export default {
  name: 'CheckProject',
  props: {
    content: {
      type: Object,
      default: -1
    }
  },
  setup: function setup(props, context) {
    // 储存接收的值
    var data = reactive({
      showDialog: props.showDialog,
      // 灯箱显示
      visible: false,
      // 灯箱索引
      index: 0,
      // default: 0
      // 灯箱图片
      imgs: []
    }); // 关闭弹窗传值

    var handleClose = function handleClose() {
      // 关闭弹窗
      context.emit('update:modelValue', false);
    }; // 打开灯箱


    var openLightbox = function openLightbox(e) {
      // 显示灯箱
      data.visible = true; // 灯箱内容

      data.imgs = props.content.project_image; // 灯箱索引值

      data.index = e;
    }; // 关闭弹窗同时关闭灯箱


    var closed = function closed() {
      // 显示灯箱
      data.visible = false;
    }; // 关闭灯箱


    var handleHide = function handleHide() {
      data.visible = false;
    }; // 结构导出


    var dataOut = toRefs(data);
    return _objectSpread(_objectSpread({
      handleClose: handleClose
    }, dataOut), {}, {
      handleHide: handleHide,
      openLightbox: openLightbox,
      closed: closed
    });
  }
};